export default __webpack_public_path__ + "static/arrow-green-up-cad511db6367e03c06bb0bfb5aecdf3d.png";